/** The site's own colour, which anything without a colour of its own is drawn in. */
export const BRAND_ACCENT = "var(--color-brand)"
